<template>
    <section class="main__content__container">
        <div class="content">
            <div class="left">
                <slot name="slider"></slot>
            </div>
            <div class="right">
                <slot name="info"></slot>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.content{
    display: flex;
    gap: 112px;
    border-top: 1px solid rgb(222, 230, 234);
    padding-top: 32px;
}
.main__content__container{

    padding-bottom: 80px;

}
.left, .right{
width: 50%;
max-width: 50%;
}
.left{
    min-width: 550px;
}

@media (max-width: 1320px) {
    .content{
        gap: 40px;
    }
} 
@media (max-width: 1024px) {
    .content{
        flex-direction: column;
    }
    .left, .right{
    width: 100%;
    max-width: unset;
    min-width: unset;
    }
}  
</style>